import React, { useState, useContext, useEffect } from 'react'
import { useLocation } from '@reach/router'
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'
import styled from 'styled-components'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

import CloseIcon from '../svg/close.svg'
import LayoutContext from './LayoutContext'
import { motion, useAnimation } from 'framer-motion'
import { FormattedMessage, useIntl } from 'react-intl'

import media from 'css-in-js-media'

const StyledCookiesNotice = styled(motion.div)`
    position: fixed;
    z-index: 200;
    bottom: 40px;
    left: 30px;
    right: 30px;
    display: flex;
    justify-content: center;
`

const CookiesNoticeContent = styled.div`
    background: white;
    color: black;
    font-weight: 500;
    border-radius: 0;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: 0.001em;
    padding: 17px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-width: 315px;

    svg {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
`

const ContentWrap = styled.div`
    display: flex;
    ${media('<desktop')} {
        flex-direction: column;
    }
    a {
        font-weight: 500;
        margin-left: 10px;
    }
`

const InnerTitle = styled.div`
    white-space: nowrap;
    margin-right: 40px;
    ${media('<desktop')} {
        margin-bottom: 20px;
    }
`

const InnerCopy = styled.div`
    font-weight: 400;
    color: #9d9d9d;
`

const Close = styled.div`
    cursor: pointer;
    margin-left: 40px;
`

const CookiesNotice: React.FC<{}> = () => {
    const location = useLocation()
    const { isGDPR, setGDPR } = useContext(LayoutContext)
    const [isActive, setActive] = useState(isGDPR)
    const AcceptedBefore = cookies.get('pazola-gdpr-google-tagmanager')

    const intl = useIntl()

    useEffect(() => {
        setGDPR(AcceptedBefore)
    }, [AcceptedBefore])

    const acceptCookies = () => {
        setActive(true)
        initializeAndTrack(location)
        setTimeout(() => {
            cookies.set('pazola-gdpr-google-tagmanager', 'yes')
        }, 300)
    }

    const controls = useAnimation()

    useEffect(() => {
        controls.start(isActive ? 'active' : 'inactive') // Second should be 'inactive'
    }, [isActive, controls])

    const CookiesNoticeStyles = {
        active: {
            opacity: 0,
            scale: 1.1,
            y: 200,
            transitionEnd: { display: 'none' },
        },
        inactive: {
            opacity: 1,
        },
    }

    return (
        <>
            {!isGDPR && (
                <StyledCookiesNotice
                    animate={controls}
                    variants={CookiesNoticeStyles}
                    transition={{
                        type: 'tween',
                        y: { type: 'spring', stiffness: 80 },
                        default: { duration: 1 },
                    }}
                >
                    <CookiesNoticeContent>
                        <ContentWrap>
                            <InnerTitle>
                                <FormattedMessage id="Cookie settings" />
                            </InnerTitle>
                            <InnerCopy>
                                <span>
                                    <FormattedMessage id="CookiesMessage" />
                                </span>
                                <a
                                    href={intl.formatMessage({
                                        id: 'CookiesLink',
                                    })}
                                    target="_blank"
                                >
                                    <FormattedMessage id="Learn more" />
                                </a>
                            </InnerCopy>
                        </ContentWrap>
                        <Close
                            onClick={() => {
                                acceptCookies()
                            }}
                        >
                            <span>
                                <FormattedMessage id="ACCEPT" />
                            </span>
                            {/* <CloseIcon /> */}
                        </Close>
                    </CookiesNoticeContent>
                </StyledCookiesNotice>
            )}
        </>
    )
}

export default CookiesNotice
